export default "<button (click)=\"saveWorkflow()\">SAVE</button>\r\n<div #graphContainer id=\"graphContainer\">\r\n</div>";